export default function visit(tree, callback) {
    if (tree && tree.children && Array.isArray(tree.children)) {
        handle(tree.children, tree, callback);
    }
}
function handle(tree, parent, callback) {
    tree.forEach((item, index) => {
        if (callback) {
            callback(item, index, parent);
        }
        if (item && Array.isArray(item.children)) {
            handle(item.children, item, callback);
        }
    });
}
//# sourceMappingURL=visit.js.map